import axios from 'axios';
import log from 'chameleon/ui-stack/utilities/log';

export const getSubmissions = (assignmentId) =>
  axios.get(
    `${FYM_BACKEND_URL}/assessments/api/assignments/${assignmentId}/submissions/`,
  );

export const getAssignmentSubmissions = (assignmentId, callback) =>
  getSubmissions(assignmentId)
    .then(({ data }) => {
      callback(data);
    })
    .catch((error) => {
      log('error', error);
    });
